import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordionContainer from "../../Components/ListViews/AccordionContainer";
import ReactSelect from "../../Components/Forms/ReactSelect";
import { Table, Container, Button, Row, Col } from "react-bootstrap";
import { adminAction } from "../../Redux/actions";
import { filterAction } from "../../Redux/actions";
import { states } from "../../Utils/arrayItems";
import { insert_data } from "../../Utils/insertData";
import DatePicker from "../../Components/Forms/DatePicker";
import { DateRangePicker } from "react-date-range";
import { TailSpin } from "react-loader-spinner";
import Filters from "../../Components/Filters";

const AdminRevenueByState = () => {
  const dispatch = useDispatch();
  const stateRevenue = useSelector((state) => state.adminReducer.adminRevenueByState);
  const stateRevenueLoaded = useSelector((state) => state.adminReducer.adminRevenueByStateLoaded);
  const default_filters = useSelector((state) => state.filterReducer.filterData);
  const savedUserFilters = useSelector((state) => state.filterReducer.savedUserFilters);
  const [filtersClicked, setFiltersClicked] = useState(false);
  const [data, setData] = useState(stateRevenue);
  const [statesSelected, setStatesSelected] = useState([]);
  const [statusSelected, setStatusSelected] = useState([]);
  const [showToggle, setShowToggle] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [summaryData, setSummaryData] = useState(null);
  const [filters, setFilters] = useState({
    clientType: ["Athlete", "Team"],
    is_active: ["Active"],
    address_state: ["All"]
  });
  const [sortingDirection, setSortingDirection] = useState({
    address_state: "ASC",
    revenue: "",
    session_commissions_paid: "",
    num_sessions: "",
    combined_commission: "",
    sale_id: ""
  });
  const sortColumn = (column) => {
    const direction = sortingDirection[column];
    if (direction === "ASC" || direction === "") {
      const sortedData = [...stateRevenue].sort((a, b) => (a[column] < b[column] ? 1 : -1));
      setData(sortedData);
      setSortingDirection({ ...sortingDirection, [column]: "DESC" });
    } else if (direction === "DESC") {
      const sortedData = [...stateRevenue].sort((a, b) => (a[column] > b[column] ? 1 : -1));
      setData(sortedData);
      setSortingDirection({ ...sortingDirection, [column]: "ASC" });
    }
  };
  const clientTypes = [
    { value: "Athlete", label: "Athlete" },
    { value: "Team", label: "Team" }
  ];
  const [clientTypesSelected, setClientTypesSelected] = useState([
    { value: "Athlete", label: "Athlete" },
    { value: "Team", label: "Team" }
  ]);
  const statuses = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" }
  ];
  const [applyClicked, setApplyClicked] = useState(false);

  useEffect(() => {
    dispatch(filterAction.loadSavedUserFilters({ filters: { page_name: "Revenue by State" } }));
  }, []);

  const handleChange = (selector, e) => {
    let newVals = [];
    if (selector != "Date Range") {
      newVals = e.filter((item) => item.value != "All");
    }
    switch (selector) {
      case "Client Type":
        if (e.length == 0) {
          setClientTypesSelected([
            { value: "Athlete", label: "Athlete" },
            { value: "Team", label: "Team" }
          ]);
        } else {
          setClientTypesSelected(e);
        }
        break;
      case "Status":
        if (e.length == 0) {
          setStatusSelected([{ value: "Active", label: "Active" }]);
        } else {
          setStatusSelected(e);
        }
        break;
      case "Date Range":
        setStartDate(new Date(e.selection.startDate).toLocaleDateString());
        setEndDate(new Date(e.selection.endDate).toLocaleDateString());
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (Object.keys(savedUserFilters).length > 0) {
      dispatch(adminAction.loadAdminRevenueByState({ filters: savedUserFilters }));
      let temp_array = [];
      for (const [key, value] of Object.entries(savedUserFilters)) {
        let temp_array = savedUserFilters[key].map((data) => {
          return {
            value: data,
            label: data
          };
        });
        if (key == "is_active") {
          setStatusSelected(temp_array);
        } else if (key == "clientType") {
          setClientTypesSelected(temp_array);
        } else if (key == "start_date") {
          setStartDate(new Date(savedUserFilters[key][0]).toLocaleDateString());
        } else if (key == "end_date") {
          setEndDate(new Date(savedUserFilters[key][0]).toLocaleDateString());
        }
      }
      temp_array.length = 0;
    } else {
      dispatch(adminAction.loadAdminRevenueByState({ filters: filters }));
    }
  }, [savedUserFilters]);

  useEffect(() => {
    setData(stateRevenue);
    // if (expenseSummary) {
    //   setSummaryData({
    //     headers: [
    //       "Total Payment",
    //       "Sum of Athlete",
    //       "Sum of Sales",
    //       "Sum of Video",
    //       "Sum of In Person",
    //       'Sum of Events',
    //       'Sum of Corporate Sessions',
    //       'Sum of Payment Adjustments',
    //       'Sum of Sales Hours',
    //       'Sum of Salary',
    //       'Sum of Bonus',
    //       'Sum of Reimbursements'
    //     ],
    //     data: [
    //       expenseSummary['Total Payment'],
    //       expenseSummary['Sum of Athlete'],
    //       expenseSummary['Sum of Sales'],
    //       expenseSummary['Sum of Video'],
    //       expenseSummary['Sum of In Person'],
    //       expenseSummary['Sum of Events'],
    //       expenseSummary['Sum of Corporate Sessions'],
    //       expenseSummary['Sum of Payment Adjustments'],
    //       expenseSummary['Sum of Sales Hours'],
    //       expenseSummary['Sum of Salary'],
    //       expenseSummary['Sum of Bonus'],
    //       expenseSummary['Sum of Reimbursements']
    //     ]
    //   });
    // }
  }, [stateRevenue]);

  const handleClick = (e) => {
    if (e.target.id == "apply") {
      let status_arr = statusSelected.map((data) => data.value);
      let client_type_arr = clientTypesSelected.map((data) => data.value);
      let states_arr = statesSelected.map((state) => state.value);
      let filtersObj = {
        start_date: [startDate],
        end_date: [endDate],
        clientType: client_type_arr,
        is_active: status_arr,
        page_name: "Revenue by State"
      };
      setFilters(filtersObj);
      setFiltersClicked(!filtersClicked);
      setApplyClicked(!applyClicked);
      insert_data(filtersObj);
    } else {
      setFiltersClicked(!filtersClicked);
    }
  };

  useEffect(() => {
    dispatch(adminAction.loadAdminRevenueByState({ filters: filters }));
  }, [applyClicked]);

  const exportData = Array.isArray(stateRevenue) ? stateRevenue.map((v) => v.breakdown).flat() : [];

  return (
    <div className="expenses-container">
      <Row className="mt-4">
        <div className="title-row">
          <div className="expenses-title">REVENUE BY STATE</div>
          <Button
            className="filters-button-client"
            onClick={() => setFiltersClicked(!filtersClicked)}>
            FILTERS
          </Button>
        </div>
      </Row>
      {filtersClicked && (
        <Filters
          setFiltersClicked={setFiltersClicked}
          filtersClicked={filtersClicked}
          onClick={handleClick}>
          <ReactSelect
            options={clientTypes}
            value={clientTypesSelected}
            isMulti={true}
            placeholder="Client Type"
            handleChange={handleChange}
          />
          <ReactSelect
            options={statuses}
            value={statusSelected}
            isMulti={true}
            placeholder="Status"
            handleChange={handleChange}
          />
          <DatePicker
            key={100}
            label={"Date Range"}
            startDate={startDate}
            endDate={endDate}
            showToggle={showToggle}
            setShowToggle={setShowToggle}
            type="range">
            <DateRangePicker
              startDatePlaceholder={startDate}
              endDatePlaceholder={endDate}
              ranges={[
                { startDate: new Date(startDate), endDate: new Date(endDate), key: "selection" }
              ]}
              onChange={(e) => handleChange("Date Range", e)}
              showPreview={false}
            />
          </DatePicker>
        </Filters>
      )}
      <Row className="mt-4">
        {!stateRevenueLoaded && (
              <div style={{ margin: 'auto' }}>
                  <TailSpin
                    visible={true}
                    height="60"
                    width="100%"
                    color="#f1eb42e9"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                  </div>
        )}
        {stateRevenueLoaded && <>
          <Table striped variant="dark" className="expenses-table" responsive>
            <thead>
              <tr>
                <th onClick={() => sortColumn("address_state")}>State</th>
                <th onClick={() => sortColumn("revenue")}>Revenue</th>
                <th onClick={() => sortColumn("session_commission_paid")}>Session Commission Paid</th>
                <th onClick={() => sortColumn("num_sessions")}>Number of Sessions</th>
                <th onClick={() => sortColumn("combined_commission")}>Sales Commission Paid</th>
                <th onClick={() => sortColumn("num_sales")}>Number of Sales</th>
              </tr>
            </thead>
            <tbody>
              {data && 
                data.map((row) => {
                  return (
                    <tr key={`{${row.address_state}`}>
                      <td>{`${row.address_state}`}</td>
                      <td>{`$${row.revenue.toLocaleString()}`}</td>
                      <td>{`$${row.session_commission_paid.toLocaleString()}`}</td>
                      <td>{`${row.num_sessions.toLocaleString()}`}</td>
                      <td>{`$${row.combined_commission.toLocaleString()}`}</td>
                      <td>{`${row.num_sales.toLocaleString()}`}</td>
                    </tr>
                  ); 
              })}
            </tbody>
        </Table>
        </>}
        {stateRevenue && stateRevenue.length === 0 && stateRevenueLoaded && <div className="data-title">No Data Available</div>}
      </Row>
    </div>
  );
};

export default AdminRevenueByState;
